"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasicTypeFromExtension = void 0;
var supportedFiles_1 = require("../supportedFiles");
var getBasicTypeFromExtension = function (filename, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 'other/*'; }
    var ext = filename.split('.').pop();
    if (!ext)
        return defaultValue;
    if (supportedFiles_1.imageExts.includes(ext))
        return 'image/*';
    if (supportedFiles_1.videoExts.includes(ext))
        return 'video/*';
    return defaultValue;
};
exports.getBasicTypeFromExtension = getBasicTypeFromExtension;
